<template>
    <div style="height:100vh;">
        <div class="row h-100 mx-0">
            <div class="col-0 col-lg-5 d-none d-lg-flex px-0">
                <div class="h-100 w-100 sb-image-background">
                    <div class="h-100 d-flex align-items-center justify-content-center text-center"
                         style="background-color: rgba(84, 19, 136, 0.4);text-shadow: 1px 1px 5px black">
                        <div>
                            <h1 class="text-white font-weight-normal mb-4 hero-title">
                                <strong>TN CyberTech Bank</strong>
                            </h1>
                            <h2 class="text-white">Everyday Banking For Everyday People</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-7 pr-0 pr-lg-1 d-flex align-items-center px-0">
                <div class="col-12">
                    <p class="text-center mt-5">Step 4 / 4</p>
                    <div class="text-center">
                        <h1>Set Pin Recovery Questions</h1>
                        <h2>Your answers will be used to help <br>you recover your pin on your own</h2>
                    </div>

                    <div class="row d-flex justify-content-center align-items-center mt-5">
                        <div class="col-10 col-lg-6">
                            <form v-bind:class="{'ui form loading' : isBusy()}" @submit.prevent="submitForm()">
                                <div class="ui big form">
                                    <div class="field">
                                        <select v-model="question1" @change="updateQuestions">
                                            <option value="">Choose a question</option>
                                            <option v-for="q in question1List" :key="q.id" :value="q.uid">{{q.question}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="ui big fluid left icon input  mt-3">
                                    <i class="tag icon"></i>
                                    <input type="text" v-model="answer1" maxlength="255" placeholder="Your answer">
                                </div>
                                <div class="ui big form mt-3">
                                    <div class="field">
                                        <select v-model="question2" @change="updateQuestions">
                                            <option value="">Choose a question</option>
                                            <option v-for="q in question2List" :key="q.id" :value="q.uid">{{q.question}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="ui big fluid left icon input  mt-3">
                                    <i class="tag icon"></i>
                                    <input type="text" v-model="answer2" maxlength="255" placeholder="Your answer">
                                </div>

                                <small v-if="errors.messageNotReadable" class="text-danger">{{
                                        errors.messageNotReadable
                                    }}</small>
                                <small v-if="errors.generalExceptionx" class="text-danger">{{
                                        errors.generalException
                                    }}</small>
                                <small v-if="errors.apiException" class="text-danger">{{
                                        errors.apiException
                                    }}</small>

                                <button class="fluid ui button mt-3" v-bind:disabled="isBusy()" type="submit">
                                    Submit
                                </button>
                                <br>
                                <a @click="close()" class="fluid ui grey tertiary button">Cancel</a>

                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import baseMethods from "@/utils/baseMethods";
import {URLS} from "@/utils/constants";
import {utils} from "@/utils/utils";

export default {
    name: "Questions",
    data (){
        return {
            model: {
                provider: 'CHANNEL',
                action: 'QUESTIONS',
                phone: localStorage.getItem('phone'),
                questionsAndAnswers: []
            },
            question1: '',
            question2: '',
            answer1: '',
            answer2: '',
            questions: [],
            question1List: [],
            question2List: [],
            errors: {},
            operations: 0
        }
    },
    mounted(){
        this.getNoAuth(URLS.questions, false)
        .then(res => {
            if (!res) return;
            if (res.errors) return this.errors = res.errors;
            this.questions = res.body;
            this.question1List = this.question2List = this.questions;
        })
    },
    methods: {
        submitForm() {
            if (!this.$route.params.sdkActionUid) {
                this.actionCheckNotification();
                return;
            }
            this.model.questionsAndAnswers = [
                {
                    questionUid: this.question1,
                    answer: this.answer1
                },
                {
                    questionUid: this.question2,
                    answer: this.answer2
                },
            ]
            this.postNoAuth(URLS.auth,
                this.model, "Security questions and answers saved successfully", null, true)
                .then(res => {
                    if (!res) return;
                    if (res.errors) return this.errors = res.errors;
                    this.$router.push("/complete/" + this.$route.params.sdkActionUid)
                })
        },
        updateQuestions(){
            let questionsCopy1 = utils.copy(this.questions);
            let questionsCopy2 = utils.copy(this.questions);

            let questionObj1 = this.questions.filter(question => question.uid === this.question1)[0];
            let questionObj2 = this.questions.filter(question => question.uid === this.question2)[0];

            let index1 = this.questions.indexOf(questionObj1);
            let index2 = this.questions.indexOf(questionObj2);

            if(index2 > -1)
                questionsCopy1.splice(index2,1);
                this.question1List = questionsCopy1;
            if(index1 > -1)
                questionsCopy2.splice(index1,1);
                this.question2List = questionsCopy2;
        },
        ...baseMethods
    }
}
</script>

<style scoped>

</style>